import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import { Toaster as Sonner } from '@/components/ui/sonner'
import { Toaster } from '@/components/ui/toaster'
import { TooltipProvider } from '@/components/ui/tooltip'
import { FeatureFlagsProvider } from '@/contexts/FeatureFlagsContext'
import { ThemeProvider } from '@/contexts/ThemeContext'
import { queryClient } from '@/lib/query-client'

import CompleteRegistrationStandard from './components/screens/CompleteRegistrationStandard'
import KycRedirectSuccess from './components/screens/KycRedirectSuccess'
import Index from './pages/Index'
import { LoginVerify } from './pages/LoginVerify'
import NotFound from './pages/NotFound'
import { SignUp } from './pages/SignUp'
import Status from './pages/Status'
import TestError from './pages/TestError'

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <FeatureFlagsProvider>
        <ThemeProvider>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/status" element={<Status />} />
                <Route path="/test-error" element={<TestError />} />
                <Route path="/LoginVerify" element={<LoginVerify />} />
                <Route
                  path="/RedirectSuccess"
                  element={
                    <KycRedirectSuccess
                      onComplete={() => (window.location.href = '/Complete24')}
                    />
                  }
                />
                <Route
                  path="/RedirectFailed"
                  element={<CompleteRegistrationStandard />}
                />
                <Route
                  path="/Complete"
                  element={
                    <KycRedirectSuccess
                      onComplete={() => (window.location.href = '/Complete24')}
                    />
                  }
                />
                <Route
                  path="/SignupKYC"
                  element={<CompleteRegistrationStandard />}
                />
                <Route
                  path="/Complete24"
                  element={<CompleteRegistrationStandard />}
                />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
            <ReactQueryDevtools initialIsOpen={false} />
          </TooltipProvider>
        </ThemeProvider>
      </FeatureFlagsProvider>
    </QueryClientProvider>
  )
}

export default App
